import type { TenantProfile } from './tenantApi';

/** The company's own "Sector · Country", or nothing: never a stand-in. */
export function tenantPlace(tenant: Pick<TenantProfile, 'sectorLabel' | 'countryCode'> | undefined): string {
  return tenant ? [tenant.sectorLabel, tenant.countryCode].filter(Boolean).join(' · ') : '';
}
